<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <path
      fill="#4f2b1b"
      d="M48,19.84c18.79,0,34.08,15.29,34.08,34.08s-15.29,34.08-34.08,34.08S13.92,72.72,13.92,53.93,29.21,19.84,48,19.84m0-4c-21.03,0-38.08,17.05-38.08,38.08s17.05,38.08,38.08,38.08,38.08-17.05,38.08-38.08S69.03,15.84,48,15.84h0Z"
    />
    <polygon
      fill="#85c441"
      points="90 69.43 6 69.43 9.11 53.93 6 38.43 90 38.43 86.89 53.93 90 69.43"
    />
    <g>
      <path
        fill="#fff"
        d="M16.76,49.76h1.01v-6h-1.01v-2h4.62v2h-1v6h2.56l.6-1.94h1.69v3.94h-8.47v-2Z"
      />
      <path
        fill="#fff"
        d="M25.76,49.76h1.01v-6h-1.01v-2h4.67v2h-1.06v6h1.06v2h-4.67v-2Z"
      />
      <path
        fill="#fff"
        d="M31.1,49.76h1v-6h-1v-2h4.68l1.56,4.11,1.49-4.11h4.69v2h-1.01v6h1.01v2h-4.6v-2h1.05v-5.54l-2.05,5.43h-1.24l-2.05-5.43v5.54h1.07v2h-4.6v-2Z"
      />
      <path
        fill="#fff"
        d="M44.18,49.76h1.01v-6h-1.01v-2h4.67v2h-1.06v6h1.06v2h-4.67v-2Z"
      />
      <path
        fill="#fff"
        d="M51.3,49.76h1.01v-6.03h-.8l-.51,1.57h-1.6v-3.54h8.43v3.54h-1.6l-.51-1.57h-.81v6.03h1.01v2h-4.62v-2Z"
      />
      <path
        fill="#fff"
        d="M58.38,49.76h1.01v-6h-1.01v-2h8.97v3.62h-1.74l-.61-1.62h-3v1.62h1.97v2.22h-1.97v2.15h3l.61-1.94h1.74v3.94h-8.97v-2Z"
      />
      <path
        fill="#fff"
        d="M68.25,49.76h1.01v-6h-1.01v-2h4.75c1.38,0,2.38,.16,3,.49,.9,.47,1.55,1.07,1.96,1.8,.41,.73,.62,1.63,.62,2.71s-.21,1.97-.62,2.7c-.42,.73-1.07,1.33-1.96,1.81-.62,.32-1.62,.49-3,.49h-4.75v-2Zm3.68,0h.78c2.09,0,3.14-1,3.14-3s-1.05-3-3.14-3h-.78v6Z"
      />
      <path
        fill="#fff"
        d="M16.72,62.74h1.01v-6h-1.01v-2h8.97v3.62h-1.74l-.61-1.62h-3v1.62h1.97v2.22h-1.97v2.15h3l.61-1.94h1.74v3.94h-8.97v-2Z"
      />
      <path
        fill="#fff"
        d="M26.59,62.74h1.01v-6h-1.01v-2h4.75c1.38,0,2.38,.16,3,.49,.9,.47,1.55,1.07,1.96,1.8,.41,.73,.62,1.63,.62,2.71s-.21,1.97-.62,2.7c-.42,.73-1.07,1.33-1.96,1.81-.62,.32-1.62,.49-3,.49h-4.75v-2Zm3.68,0h.78c2.09,0,3.14-1,3.14-3s-1.05-3-3.14-3h-.78v6Z"
      />
      <path
        fill="#fff"
        d="M37.6,62.74h1.01v-6h-1.01v-2h4.67v2h-1.06v6h1.06v2h-4.67v-2Z"
      />
      <path
        fill="#fff"
        d="M44.72,62.74h1.01v-6.03h-.8l-.51,1.57h-1.6v-3.54h8.43v3.54h-1.6l-.51-1.57h-.81v6.03h1.01v2h-4.62v-2Z"
      />
      <path
        fill="#fff"
        d="M51.8,62.74h1.01v-6h-1.01v-2h4.67v2h-1.06v6h1.06v2h-4.67v-2Z"
      />
      <path
        fill="#fff"
        d="M58.94,55.81c.97-.84,2.15-1.26,3.54-1.26s2.58,.42,3.55,1.26c1.19,1.06,1.79,2.37,1.79,3.93s-.6,2.88-1.79,3.93c-.97,.84-2.16,1.26-3.55,1.26s-2.57-.42-3.54-1.26c-1.19-1.05-1.79-2.37-1.79-3.93s.6-2.89,1.79-3.93Zm1.7,5.92c.5,.52,1.11,.78,1.85,.78s1.36-.26,1.85-.77,.74-1.18,.74-2.01-.25-1.48-.74-2.01c-.5-.52-1.11-.79-1.85-.79s-1.35,.26-1.85,.79c-.5,.53-.75,1.19-.75,2s.25,1.47,.74,1.99Z"
      />
      <path
        fill="#fff"
        d="M68.5,62.74h1.01v-6h-1.01v-2h3.55l3.33,5.51-.08-3.51h-1.07v-2h4.6v2h-1v8h-2.17l-3.68-6.03,.06,4.03h1.06v2h-4.6v-2Z"
      />
    </g>
    <path
      fill="#85c441"
      d="M48.26,71.45l2,4.04c.04,.09,.13,.15,.22,.16l4.46,.65c.24,.03,.34,.33,.16,.5l-3.23,3.15c-.07,.07-.1,.16-.08,.26l.76,4.44c.04,.24-.21,.42-.43,.31l-3.99-2.1c-.09-.04-.19-.04-.27,0l-3.99,2.1c-.22,.11-.47-.07-.43-.31l.76-4.44c.02-.1-.02-.19-.08-.26l-3.23-3.15c-.17-.17-.08-.47,.16-.5l4.46-.65c.1-.01,.18-.07,.22-.16l2-4.04c.11-.22,.42-.22,.53,0Z"
    />
    <path
      fill="#85c441"
      d="M33.61,71.41l1.45,2.94c.03,.06,.09,.11,.16,.12l3.24,.47c.17,.03,.24,.24,.12,.36l-2.34,2.28c-.05,.05-.07,.12-.06,.19l.55,3.23c.03,.17-.15,.31-.31,.22l-2.9-1.52c-.06-.03-.14-.03-.2,0l-2.9,1.52c-.16,.08-.34-.05-.31-.22l.55-3.23c.01-.07-.01-.14-.06-.19l-2.34-2.28c-.13-.12-.06-.34,.12-.36l3.24-.47c.07-.01,.13-.05,.16-.12l1.45-2.94c.08-.16,.3-.16,.38,0Z"
    />
    <path
      fill="#85c441"
      d="M62.77,71.41l1.45,2.94c.03,.06,.09,.11,.16,.12l3.24,.47c.17,.03,.24,.24,.12,.36l-2.34,2.28c-.05,.05-.07,.12-.06,.19l.55,3.23c.03,.17-.15,.31-.31,.22l-2.9-1.52c-.06-.03-.14-.03-.2,0l-2.9,1.52c-.16,.08-.34-.05-.31-.22l.55-3.23c.01-.07-.01-.14-.06-.19l-2.34-2.28c-.13-.12-.06-.34,.12-.36l3.24-.47c.07-.01,.13-.05,.16-.12l1.45-2.94c.08-.16,.3-.16,.38,0Z"
    />
    <path
      fill="#85c441"
      d="M48.26,23.45l2,4.04c.04,.09,.13,.15,.22,.16l4.46,.65c.24,.03,.34,.33,.16,.5l-3.23,3.15c-.07,.07-.1,.16-.08,.26l.76,4.44c.04,.24-.21,.42-.43,.31l-3.99-2.1c-.09-.04-.19-.04-.27,0l-3.99,2.1c-.22,.11-.47-.07-.43-.31l.76-4.44c.02-.1-.02-.19-.08-.26l-3.23-3.15c-.17-.17-.08-.47,.16-.5l4.46-.65c.1-.01,.18-.07,.22-.16l2-4.04c.11-.22,.42-.22,.53,0Z"
    />
    <path
      fill="#85c441"
      d="M33.61,27.17l1.45,2.94c.03,.06,.09,.11,.16,.12l3.24,.47c.17,.03,.24,.24,.12,.36l-2.34,2.28c-.05,.05-.07,.12-.06,.19l.55,3.23c.03,.17-.15,.31-.31,.22l-2.9-1.52c-.06-.03-.14-.03-.2,0l-2.9,1.52c-.16,.08-.34-.05-.31-.22l.55-3.23c.01-.07-.01-.14-.06-.19l-2.34-2.28c-.13-.12-.06-.34,.12-.36l3.24-.47c.07-.01,.13-.05,.16-.12l1.45-2.94c.08-.16,.3-.16,.38,0Z"
    />
    <path
      fill="#85c441"
      d="M62.77,27.17l1.45,2.94c.03,.06,.09,.11,.16,.12l3.24,.47c.17,.03,.24,.24,.12,.36l-2.34,2.28c-.05,.05-.07,.12-.06,.19l.55,3.23c.03,.17-.15,.31-.31,.22l-2.9-1.52c-.06-.03-.14-.03-.2,0l-2.9,1.52c-.16,.08-.34-.05-.31-.22l.55-3.23c.01-.07-.01-.14-.06-.19l-2.34-2.28c-.13-.12-.06-.34,.12-.36l3.24-.47c.07-.01,.13-.05,.16-.12l1.45-2.94c.08-.16,.3-.16,.38,0Z"
    />
  </svg>
</template>
